<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import productionProcess from "./../productionProcess/index.vue";
import woven from "./modules/woven.vue";
import simpleWoven from "./simpleWoven/index.vue";
import simpleWovenNew from "./simpleWovenNew/index.vue";
@Component({
  name: "production-process-print",
  components: {
    productionProcess,
    woven,
    simpleWoven,
    simpleWovenNew
  }
})
export default class App extends Vue {
  pageType = null;
  info = {};
  mounted() {
    const { isWoollen } = this.$route.query;
    this.pageType = Number(isWoollen);
    this.$apis.autoAPi
        .POST_TECHNICS_PRO_DETAIL_GET({
        id: this.$route.query.id,
        materialCode: this.$route.query.materialCode
      })
      .done(res => {
        res.data.detailItemList = res.data.detailItemList || []
        res.data.pattern = res.data.pattern ? res.data.pattern.split(",")
        .map((item) => ({
          comment: item,
          code: item,
        })) : []
        this.info = res.data;
      })
      .fail(err => {});
  }
  render(h) {
    return (
      <div class="production-process-print">
        {/** 毛织*/}
        {this.pageType === 1 && <productionProcess></productionProcess>}
        {this.pageType >= 2 && this.pageType <= 14 && (
          <woven info={this.info} type={this.pageType}></woven>
        )}
        {
          this.pageType > 14 && this.pageType < 17 && (<simple-woven info={this.info}></simple-woven>)
        }
        {
          this.pageType == 17 && (<simple-woven-new info={this.info}></simple-woven-new>)
        }
      </div>
    );
  }
}
</script>

<style>
  
.production-process-print .el-checkbox-group .el-checkbox__label {
  font-size: 3mm !important;
}

</style>
